import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms';

import { modalStore } from 'apps/modals/app';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { Trans } from 'react-i18next';
import { CategoryFormAppManager } from 'apps/forum/categoryForm/appManager';

@observer
export class CategoryForm extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new CategoryFormAppManager(
      modalStore.props.parent,
      modalStore.props,
    );
  }

  render() {
    const { categoryApp } = this.appManager;
    const { form } = categoryApp;
    const {
      conf: { formTitle },
    } = form;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          buttonHandler={this.appManager.Submit}
          noBorder={true}
          padding='0'
        />
      </>
    );
  }
}
